import { MarketButton } from '@squareup/dex-ui-shared-market';
import React, {
  AriaAttributes,
  FC,
  MouseEventHandler,
  PropsWithChildren,
} from 'react';

import styles from './combobox.module.css';

interface Props {
  onClick: MouseEventHandler<globalThis.HTMLMarketButtonElement>;
}

const ComboboxActionButton: FC<PropsWithChildren<Props & AriaAttributes>> = ({
  onClick,
  children,
  ...rest
}) => {
  return (
    <MarketButton
      onClick={onClick}
      className={styles['action-button']}
      rank="tertiary"
      size="small"
      testId="combobox-action-button"
      trackingId="combobox-action-button"
      {...rest}
    >
      {children}
    </MarketButton>
  );
};

export { ComboboxActionButton };
